import { Component, OnInit, Inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MdDialog, MdDialogRef, MD_DIALOG_DATA, SnackBarState, MdSnackBar } from "@angular/material";

import { IncassoContantiListItemModel } from "../../models/incassi/incasso-contanti-list-item.model";
import { IncassoAssegniListItemModel } from '../../models/incassi/incasso-assegni-list-item.model';
import { IncassoModel } from "../../models/incassi/incasso.model";
import { DizionarioModel } from '../../models/shared/dizionario.model';
import { DizionariService } from './../../services/dizionari.service';
import { TaglioMonetaModel } from './../../models/shared/taglio-moneta.model';
import { IncassiDettaglioService } from '../../services/incassi-dettaglio.service';
import { IncassiService } from '../../services/incassi.service';

export class DistintaContantiDialogConfigModel {
  // riferimento, da lasciare invariato! è competenza del chiamante
  constructor(public incassoRef: IncassoModel, public showAssegnoCircolare: boolean) { }
}

@Component({
  selector: 'app-distinta-contanti',
  templateUrl: './distinta-contanti.component.html',
  styleUrls: ['./distinta-contanti.component.css']
})
export class DistintaContantiDialog {

  saving: Boolean = false;
  config: DistintaContantiDialogConfigModel = null;

  // mantiene una copia locale dei dati dell'incasso passati come parametro dal chiamante
  incassoCorrente: IncassoModel = null;

  constructor(
    private incassiService: IncassiService,
    private incassiDettaglioService: IncassiDettaglioService,
    private dizionariService: DizionariService,
    public dialogRef: MdDialogRef<DistintaContantiDialog>,
    private snackBar:MdSnackBar,
    @Inject(MD_DIALOG_DATA) public data: DistintaContantiDialogConfigModel) {

    this.config = data;

    this.incassoDeepCopy(this.config.incassoRef);
    this.buildForm();
  }



  private showError(msg: string) {
    this.snackBar.open(msg, 'Chiudi', { duration: 4000 });
  }


  // effettua una copia dell'incasso
  private incassoDeepCopy(m: IncassoModel) {
    this.incassoCorrente = {
      tokenIncasso: m.tokenIncasso,
      tokenCliente: m.tokenCliente,
      dataIncasso: m.dataIncasso,
      totaleValuta: m.totaleValuta,
      totaleAssegni: m.totaleAssegni,
      totaleIncasso: m.totaleIncasso,
      statoIncasso: m.statoIncasso,
      id: m.id,
      zona: m.zona,
      clienteRagioneSociale: m.clienteRagioneSociale
    };

    if (m.contanti) {
      this.incassoCorrente.contanti = m.contanti.map(
        (cont: IncassoContantiListItemModel) => Object.assign({}, cont)
      );
    }
    if (m.assegni) {
      this.incassoCorrente.assegni = m.assegni.map(
        (assegno: IncassoAssegniListItemModel) => Object.assign({}, assegno)
      );
    }

  }

  // costruisce la form sulla base di this.incassoCorrente
  // nel caso non vi siano contanti, inizializza l'array con tutte le decodifiche dei contanti disponibili
  private buildForm(): void {

    if (!this.incassoCorrente.contanti || this.incassoCorrente.contanti.length === 0) {
      this.incassoCorrente.contanti = [];
      this.dizionariService
        .getTagliMoneta()
        .subscribe((t: TaglioMonetaModel[]) => {
          for (let m of t) {
            this.incassoCorrente.contanti.push({
              idTaglio: m.id,
              descrizioneTaglio: m.descrizione,
              token: '',
              importoTaglio: m.importo
            });
          }
        });
    }

  }
  
  updateImporto(row: IncassoContantiListItemModel): void {
    row.importo = row.importoTaglio * row.quantita;
  }

  getTotal(): number {
    this.incassoCorrente.totaleValuta = 0;
    this.incassoCorrente.contanti.forEach(i => {
      if (!isNaN(i.importo)) {
        this.incassoCorrente.totaleValuta += +i.importo;
      }
    });
    return this.incassoCorrente.totaleValuta;
  }

  canSave() {
    // i dati sono modificabili solo se l'incasso è nuovo o in lavorazione
    //NB: la verifica dello stato viene fatta sul riferimento all'incasso originale
    return this.config.incassoRef.statoIncasso.id < 3;
  }
  
  // in caso di salvataggio viene restituito il nuovo oggetto dell'incasso
  salva() {

    let regexNumeri=/^\d+$/;
    for(let i=0;i<this.incassoCorrente.contanti.length;i++) {
      let incassoContante=this.incassoCorrente.contanti[i];
      if(incassoContante.quantita!==undefined&&incassoContante.quantita!=null&&incassoContante.quantita+''!=='') {
        if(!regexNumeri.test(incassoContante.quantita+'')) {
          this.showError("Le quantità delle banconote devono essere numeriche");
          return;
        }
      }
      let rex=/^(\d+(\.\d{1,2}){0,1})$/;
      if(incassoContante.idTaglio===8) {
        if((incassoContante.importo||'')!==''&&!rex.test(incassoContante.importo+'')) {
          this
            .showError
              // tslint:disable-next-line:max-line-length
              ('Il campo importo delle monete deve rappresentare un numero decimale valido per la valuta, il separatore da intero a decimale deve essere "."');
          return;
        }
      }
    }
    this.saving=true;
    //è una insert/update con controllo lato server 
    this.incassiDettaglioService.insertContanti(this.incassoCorrente.contanti, this.incassoCorrente.tokenIncasso)
      .subscribe(resA => {
        if(resA.result.result) {
        this.incassiDettaglioService.getContanti(this.incassoCorrente.tokenIncasso)
        .subscribe(
          resC => {
             this.incassoCorrente.contanti= resC;
             this.saving=false;

             if (this.incassoCorrente.statoIncasso.id === 1) {
              //aggiorno lo stato
              this.incassoCorrente.statoIncasso.id = 2;
              this.saving=true;
              this.incassiService.update(this.incassoCorrente).subscribe((data: any) => {
                console.log();
                this.saving=false;
              });
            }
             this.dialogRef.close(this.incassoCorrente);
        }, error=> {
          this.saving=false;
        });
      } else {
        this.saving=false;
        this.showError(resA.result.message);
      }
      },
      error => {
        this.saving=false;
        
      });
    
  }

  // in caso di annullamento dell'operazione (o chiusura senza modifica), restituisco null
  annulla() {
    this.dialogRef.close(null);
  }
}





// WEBPACK FOOTER //
// C:/ETT/Progetti/JumpvNext/Angular/AgentiWebUI/AgentiWebConqordOil.Web.UI/src/app/components/incassi/distinta-contanti.component.ts